export default __webpack_public_path__ + "static/media/13.37691ed6.png";